var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStoreDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_968",
    "data-name": "Rectangle 968",
    width: 12.551,
    height: 14,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App_store_-_Color",
    "data-name": "App store - Color",
    transform: "translate(-815 -621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3128",
    "data-name": "Group 3128",
    transform: "translate(815.724 621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3127",
    "data-name": "Group 3127",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M395.091,273.3l-.009-.005-3.232,3.014,3.229,2.966.011-.007,2.756-1.591a1.609,1.609,0,0,0,0-2.787Z",
    transform: "translate(-386.1 -269.28)",
    fill: "#ffc41f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M0,484.071H0a1.609,1.609,0,0,0,2.413,1.393l6.566-3.791L5.75,478.707Z",
    transform: "translate(0 -471.682)",
    fill: "#e83e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M0,118.824v10.645l5.75-5.364Z",
    transform: "translate(0 -117.08)",
    fill: "#4385f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M8.982,4.011,2.413.219A1.609,1.609,0,0,0,0,1.612v.132L5.75,7.026Z",
    transform: "translate(0 -0.001)",
    fill: "#009245"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 14,
    height: 14,
    transform: "translate(815 621)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreDarkIcon);
export default __webpack_public_path__ + "static/media/play-store-dark-icon.420f210ba36412a3efb06b54d702c0f6.svg";
export { ForwardRef as ReactComponent };